import React from 'react'
import styles from './add-group.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import * as Yup from 'yup'
import { Formik } from 'formik'

const SetAgeGroups = ({
  classes,
  opened,
  requestClose = () => null,
  initialAgeGroup,
  onSubmit,
  pending
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>Create a new group</ModalHeader>
    <Formik
      validationSchema={Yup.object().shape({
        groupName: Yup.string().required('Please provide a name for your group')
      })}
      onSubmit={onSubmit}
      initialValues={{
        groupName: ''
      }}>
      {props => {
        const {
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          errors,
          isValid
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              <FormInput
                validationError={errors.groupName}
                placeholder="The name of the group"
                name="groupName"
                value={values.groupName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                type="button"
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button disabled={!isValid || pending} tall type="submit">
                {!pending && 'Create group'}
                {pending && 'Creating'}
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(SetAgeGroups)
